var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircleIconOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#fff",
    stroke: "#A28C50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.081 5.902L8.234 10.79 5.832 9.068a.687.687 0 00-.952.15.67.67 0 00.152.943l2.878 2.061a.684.684 0 00.886-.074l5.259-5.3a.67.67 0 00-.01-.955.687.687 0 00-.964.01z",
    fill: "#A28C50"
  })));
}

export default SvgCheckCircleIconOutline;